module.exports = __webpack_public_path__ + "static/mj-024f8ea7ac6c00e669e73fd618e1306e.png";